export const cuisinesData = [
  {
    name: "Tteok-bokki",
    name_in_Eng: "Simmered rice cake",
    view: 940872585,
    ingredients: [
      "tteok",
      "fish cake",
      "green cabbage",
      "scallion",
      "gochujang",
      "gochugaru",
      "soy sauce",
      "sugar",
      "garlic",
    ],
    source:
      "https://www.yummly.com/recipe/Tteokbokki---Spicy-Stir-fried-Rice-Cakes-9229939",
    img: "../img/cuisines/Tteok-bokki.svg",
  },
  {
    name: "Kimchi",
    name_in_Eng: "",
    view: 410335699,
    ingredients: [
      "napa cabbage",
      "daikon radish",
      "salt",
      "rice flour",
      "gochugaru",
      "fish sauce",
      "salted shrimp sauce",
      "scallion",
      "garlic",
      "sugar",
    ],
    source: "https://www.food.com/recipe/kimchi-or-kimchee-173218",
    img: "../img/cuisines/Kimchi.svg",
  },

  {
    name: "Gimbap",
    name_in_Eng: "",
    view: 248022507,
    ingredients: [
      "rice",
      "vinegar",
      "soy sauce",
      "sesame oil",
      "seaweed",
      "carrot",
      "egg",
      "spinach",
      "pickled yellow radish",
      "sesame seed",
    ],
    source: "https://www.food.com/recipe/kim-bap-korean-rice-rolls-46970",
    img: "../img/cuisines/Gimbap.svg",
  },

  {
    name: "Tteok",
    name_in_Eng: "Korean rice cake",
    view: 203045259,
    ingredients: ["rice"],
  },

  {
    name: "Galbi",
    name_in_Eng: "grilled rib",
    view: 134924157,
    ingredients: [
      "beef short rib",
      "soy sauce",
      "sugar",
      "honey",
      "sesame oil",
      "asian pear",
      "onion",
      "scallion",
      "garlic",
      "ginger",
      "black pepper",
      "sesame seed",
    ],
    img: "../img/cuisines/Galbi.svg",
  },

  {
    name: "Bibimbap",
    name_in_Eng: "",
    view: 58078179,
    ingredients: [
      "short grain rice",
      "beef",
      "soybean sprout",
      "spinach",
      "cucmber",
      "zucchini",
      "carrot",
      "garlic",
      "scallion",
      "soy sauce",
      "sesame oil",
      "sesame seed",
      "salt",
      "pepper",
      "egg",
      "gochujang",
      "vegetable oil",
    ],
    source: "https://www.yummly.com/recipe/Bibimbap-1241889",
    img: "../img/cuisines/Bibimbap.svg",
  },

  {
    name: "Soju",
    name_in_Eng: "",
    view: 56657952,
    ingredients: [""],
    source: "",
    img: "",
  },

  {
    name: "Sundae",
    name_in_Eng: "Korean blood sausage",
    view: 55920522,
    ingredients: [
      "pork intestine",
      "sweet rice",
      "potato starch",
      "garlic",
      "ginger",
      "salt",
      "pepper",
      "sesame oil",
      "sesame seed",
      "scallion",
      "pork blood",
    ],
    source: "https://travelfoodatlas.com/blood-sausage-recipe-soondae",
    img: "",
  },

  {
    name: "Bulgogi",
    name_in_Eng: "",
    view: 51759696,
    ingredients: [
      "beef",
      "scallion",
      "onion",
      "carrot",
      "soy sauce",
      "sugar",
      "honey",
      "garlic",
      "sesame oil",
      "sesame seed",
      "pepper",
    ],
    source: "https://www.yummly.com/recipe/Bulgogi-2265691",
    img: "../img/cuisines/Bulgogi.svg",
  },

  {
    name: "Mandu",
    name_in_Eng: "Koren dumpling",
    view: 49238311,
    ingredients: [
      "dumpling wrapper",
      "kimchi",
      "tofu",
      "soybean sprout",
      "onion",
      "pork",
      "scallion",
      "garlic",
      "ginger",
      "sesame oil",
      "soy sauce",
      "egg",
      "salt",
      "pepper",
      "vinegar",
      "sugar",
      "gochugaru",
    ],
    source:
      "https://www.yummly.com/recipe/Mandu-Recipe-_Korean-Dumplings_-496808",
    img: "../img/cuisines/Mandu.svg",
  },

  {
    name: "Hotteok",
    name_in_Eng: "Filled pancake",
    view: 45028896,
    ingredients: [
      "active dry yeast",
      "sugar",
      "flour",
      "salt",
      "vegetable oil",
      "cinnamon powder",
      "seed",
    ],
    source:
      "https://www.yummly.com/recipe/Hotteok-_Sweet-Korean-Pancakes_-2669362",
    img: "",
  },

  {
    name: "Jeon",
    name_in_Eng: "",
    view: 35716360,
    ingredients: [
      "soy sauce",
      "vinegar",
      "sesame oil",
      "garlic",
      "sesame seed",
      "prawn",
      "black pepper",
      "flour",
      "corn starch",
      "egg",
      "vegetable oil",
      "onion",
      "chili pepper",
    ],
    source:
      "https://www.food.com/recipe/seafood-green-onion-pancake-haemul-pa-jeon-531272",
    img: "../img/cuisines/Jeon.svg",
  },

  {
    name: "Samgyeopsal",
    name_in_Eng: "grilled pork belly",
    view: 33588346,
    ingredients: ["pork belly"],
    img: "../img/cuisines/Samgyeopsal.svg",
  },

  {
    name: "Gangjeong",
    name_in_Eng: "deep-fried rice puff",
    view: 31633252,
    ingredients: ["rice flour", "honey", "bean", "nut", "seed", "pollen"],
    img: "",
  },

  {
    name: "Kimchi-bokkeum-bap",
    name_in_Eng: "Kimchi fried rice",
    view: 25112211,
    ingredients: [
      "vegetable oil",
      "egg",
      "garlic",
      "onion",
      "kimchi",
      "rice",
      "soy sauce",
      "sesame oil",
      "black pepper",
      "scallion",
    ],
    source: "https://www.yummly.com/recipe/Kimchi-Fried-Rice-2561131",
    img: "../img/cuisines/Kimchi-bokkeum-bap.svg",
  },

  {
    name: "Kimchi-jjigae",
    name_in_Eng: "kimchi stew",
    view: 20227111,
    ingredients: [
      "kimchi",
      "pork belly",
      "gochugaru",
      "garlic",
      "ginger",
      "kimchi juice",
      "tofu",
      "scallion",
      "salt",
      "black pepper",
    ],
    source: "https://www.yummly.com/recipe/Kimchi-JJigae-_Kimchi-Stew_-2675580",
    img: "../img/cuisines/Kimchi-jjigae.svg",
  },

  {
    name: "Janchi-guksu",
    name_in_Eng: "",
    view: 14168323,
    ingredients: [
      "noodle",
      "sesame seed",
      "seaweed",
      "egg",
      "daikon radish",
      "onion",
      "scallion",
      "salt",
      "kelp",
    ],
    source: "https://www.maangchi.com/recipe/guksu",
    img: "../img/cuisines/Janchi-guksu.svg",
  },

  {
    name: "Kal-guksu",
    name_in_Eng: "Korean knife cut noodle soup",
    view: 13576603,
    ingredients: [
      "chicken breast",
      "garlic",
      "onion",
      "flour",
      "potato starch",
      "zucchini",
      "vegetable oil",
      "sesame oil",
      "salt",
      "fish sauce",
      "soy sauce",
      "black pepper",
      "kelp",
    ],
    source: "https://www.maangchi.com/recipe/dak-kalguksu",
    img: "../img/cuisines/Kal-guksu.svg",
  },

  {
    name: "Japchae",
    name_in_Eng: "stir-fried glass noodles",
    view: 13017909,
    ingredients: [
      "glass noodle",
      "carrot",
      "onion",
      "scallion",
      "beef",
      "shiitake mushroom",
      "spinach",
      "vegetable oil",
      "salt",
      "black pepper",
      "soy sauce",
      "garlic",
      "sesame seed",
      "egg",
    ],
    source: "https://www.yummly.com/recipe/Japchae-2265604",
    img: "../img/cuisines/Japchae.svg",
  },

  {
    name: "Budae jjigae",
    name_in_Eng: "Army stew",
    view: 12094712,
    ingredients: [
      "kimchi",
      "pork",
      "spam",
      "tofu",
      "ham",
      "onion",
      "red bell pepper",
      "scallion",
      "gochugaru",
      "gochujang",
      "soy sauce",
      "garlic",
      "black pepper",
      "noodle",
    ],
    source: "https://www.yummly.com/recipe/Budae-Jjigae-_Army-Stew_-2496960",
    img: "../img/cuisines/Budae jjigae.svg",
  },
];
